import { Observable } from 'rxjs';
import { Role, SettingsApi, SingleThemeResponse, Theme } from 'src/app/hickory-api';
import { getSingle } from './data/SingleHelper';
import { mockHandler } from '../mock.handler';

export class MockSettingsApi extends SettingsApi {

  id = 0;
  roles: any[] = [
    {
      id: this.id++, name: 'Healer', defaultAlertFormId: '', pollAlertFormId: '', permissions: [
        { 'id': 'admin', 'name': 'Admin', title: '' },
        { 'id': 'read', 'name': 'Read', title: '' },
        { 'id': 'write', 'name': 'Write', title: '' },
      ]
    },
    {
      id: this.id++, name: 'Tank', defaultAlertFormId: '', pollAlertFormId: '', permissions: [
        { 'id': 'admin', 'name': 'Admin', title: '' },
        { 'id': 'chat', 'name': 'Chat', title: '' },
        { 'id': 'send alert', 'name': 'Send Alert', title: '' },
        { 'id': 'something', 'name': 'Something', title: '' },
        { 'id': 'item1', 'name': 'Item1', title: '' },
        { 'id': 'item2', 'name': 'Item2', title: '' },
        { 'id': 'item3', 'name': 'Item3', title: '' },
      ]
    },
    {
      id: this.id++, name: 'DPS', defaultAlertFormId: '', pollAlertFormId: '', permissions: [
        { 'id': 'item4', 'name': 'Item4', title: '' },
        { 'id': 'running', 'name': 'Running', title: '' },
        { 'id': 'out', 'name': 'Out', title: '' },
        { 'id': 'of', 'name': 'Of', title: '' },
        { 'id': 'ideas', 'name': 'Ideas', title: '' },
      ]
    }];

  permissions: any[] = [
    { 'id': 'admin', 'name': 'Admin', permissionGroup: '1' },
    { 'id': 'read', 'name': 'Read', permissionGroup: '2' },
    { 'id': 'write', 'name': 'Write', permissionGroup: '3' },
    { 'id': 'chat', 'name': 'Chat', permissionGroup: '4' },
    { 'id': 'send alert', 'name': 'Send Alert', permissionGroup: '5' },
    { 'id': 'something', 'name': 'Something', permissionGroup: '1' },
    { 'id': 'item1', 'name': 'Item1', permissionGroup: '2' },
    { 'id': 'item2', 'name': 'Item2', permissionGroup: '3' },
    { 'id': 'item3', 'name': 'Item3', permissionGroup: '4' },
    { 'id': 'item4', 'name': 'Item4', permissionGroup: '5' },
    { 'id': 'running', 'name': 'Running', permissionGroup: '1' },
    { 'id': 'out', 'name': 'Out', permissionGroup: '1' },
    { 'id': 'of', 'name': 'Of', permissionGroup: '2' },
    { 'id': 'ideas', 'name': 'Ideas', permissionGroup: '3' },
    { 'id': 'so', 'name': 'So', permissionGroup: '4' },
    { 'id': 'stalling', 'name': 'Stalling', permissionGroup: '5' },
  ];

  getRoles(page?: number, pageSize?: number): Observable<any> {
    return mockHandler({ 'items': this.roles });
  }

  createRole(role: Role): Observable<any> {
    this.roles.push(role);
    const newId = this.roles.length - 1;
    role.id = newId;
    return mockHandler({ 'item': role, 'status': { 'isSuccess': true, 'errorCode': '' } });
  }

  getPermissions(type?: string, page?: number, pageSize?: number): Observable<any> {
    return mockHandler({ 'items': this.permissions });
  }

  getRoleById(id: number): Observable<any> {
    let foundRole: Role;
    this.roles.forEach(function (role) {
      if (role.id === id) {
        foundRole = role;
      }
    });
    if (foundRole !== undefined) {
      return mockHandler({ 'item': foundRole });
    } else {
      console.error('No role with the ID:' + id + ' was found.');
    }
  }
  updateRole(id: number, updatedRole: Role): Observable<any> {
    this.roles.forEach(function (role) {
      if (role.id === id) {
        role.name = updatedRole.name;
        role.permissions = updatedRole.permissions;
      }
    });
    return mockHandler({ 'item': updatedRole, 'status': { 'isSuccess': false, 'errorCode': 'Forbidden' } });
  }
  deleteRole(roleId: number): Observable<any> {
    let deletedRole: Role;
    this.getRoleById(roleId).subscribe(r => {
      deletedRole = r.item;
      const roleIndex = this.roles.indexOf(deletedRole);
      if (roleIndex !== -1) {
        this.roles.splice(roleIndex, 1);
      }
    });
    return mockHandler({});

  }

  getTheme(): Observable<any> {
    const response: SingleThemeResponse = getSingle({
      theme: Theme.ThemeEnum.Default
    });
    return mockHandler(response);
  }
}
